module.exports = __webpack_public_path__ + "static/img/终端1.be0e938.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/buliding/终端1.png
// module id = EBp/
// module chunks = 1